import React, { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import {
  DashBoardSvg,
  UsersSvg,
  AdminSvg,
  ModulesSvg,
  PermissionSvg,
  RolesSvg,
  AccessControlSvg,
  ManageUserSvg,
  BoxSvg,
  TruckSvg,
  TruckWhiteSvg,
  BuildingSvg,
  BuildingWhiteSvg,
  IdCardSvg,
  WalletSvg,
} from "../svgFile";
import { usePermissions } from "../components/admin/context/PermissionContext";

export const AdminSidebar = ({ isOpen = true, onToggle }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(
    localStorage.getItem("open") === "true"
  );
  const [links, setLinks] = useState([]);
  const [openCategory, setOpenCategory] = useState(null);
  const location = useLocation();

  const {
    modules,
    isSuperAdmin,
    getAllAccessibleModules,
    getModuleRoute,
    loading,
    hasPermission
  } = usePermissions();
  const toggleCategory = (categoryName) => {
    setOpenCategory(openCategory === categoryName ? null : categoryName);
  };
  useEffect(() => {
    const updateSidebar = () => {
      setIsSidebarOpen(localStorage.getItem("open") === "true");
    };

    window.addEventListener("sidebarToggle", updateSidebar);

    return () => {
      window.removeEventListener("sidebarToggle", updateSidebar);
    };
  }, []);
  const getDefaultRoute = (moduleName) => {
    const routeMap = {
      'manageUsers': '/admin/users',
      'manageModule': '/admin/modules',
      'manageAdmins': '/admin/manage-admins',
      'manageRoles': '/admin/roles',
      'managePermissions': '/admin/permissions',
      'manageDisporaCommunity': '/admin/dispora-community',
      'manageMarketPlaceCategories': '/admin/market-place/categories',
      'manageNetworkImmigrantResourceHub': '/admin/immigrant/resource-hub',
      'manageCustomer': '/admin/customers',
      'manageShipper': '/admin/shippers',
      'manageVehicleType': '/admin/fleet/vehicle-types',
      'manageVehicleMake': '/admin/fleet/vehicle-makes',
      'manageCargoType': '/admin/fleet/cargo-types',
      'manageBusinessType': '/admin/fleet/business-types',
      'manageShipments': '/admin/shipments',
      'managePendingShipments': '/admin/shipments-pending',
      'manageLicenseType': '/admin/fleet/license-types',
      'managePayments': '/admin/payments',
    };
    return routeMap[moduleName] || '#';
  };

  useEffect(() => {
    if (loading) return;

    const menuStructure = [
      {
        category: "User Management",
        icon: <ManageUserSvg />,
        permission: 'user.view',
        subcategories: [
          // {
          //   moduleName: 'manageUsers',
          //   roleName: "Users",
          //   icon: <UsersSvg />,
          //   permission: 'user.view'
          // },
          // {
          //   moduleName: 'manageAdmins',
          //   roleName: "Admins",
          //   icon: <AdminSvg />,
          //   permission: 'admin.view'
          // },
          {
            moduleName: 'manageCustomer',
            roleName: "Customers",
            icon: <UsersSvg />,
            permission: 'customer.view'
          },
          {
            moduleName: 'manageShipper',
            roleName: "Shippers",
            icon: <UsersSvg />,
            permission: 'shipper.view'
          },
        ]
      },
      {
        category: "Shipments",
        icon: <TruckWhiteSvg />,
        permission: 'shipment.view',
        subcategories: [
          {
            moduleName: 'manageShipments',
            roleName: "All Shipments",
            icon: <TruckWhiteSvg />,
            permission: 'shipment.view'
          },
          {
            moduleName: 'managePendingShipments',
            roleName: "Admin Assisted",
            icon: <BoxSvg />,
            permission: 'shipment.pending'
          },
        ]
      },
      {
        category: "Master",
        icon: <ModulesSvg />,
        permission: 'fleet.view',
        subcategories: [
          {
            moduleName: 'manageVehicleType',
            roleName: "Vehicle Type",
            icon: <ModulesSvg />,
            permission: 'vehicle.type.view'
          },
          {
            moduleName: 'manageVehicleMake',
            roleName: "Make",
            icon: <ModulesSvg />,
            permission: 'vehicle.make.view'
          },
          {
            moduleName: 'manageCargoType',
            roleName: "Cargo Types",
            icon: <BoxSvg />,
            permission: 'cargo.type.view'
          },
          {
            moduleName: 'manageBusinessType',
            roleName: "Business Types",
            icon: <BuildingWhiteSvg />,
            permission: 'business.type.view'
          },
          {
            moduleName: 'manageLicenseType',
            roleName: "License Types",
            icon: <IdCardSvg />,
            permission: 'license.type.view'
          },
        ]
      },
      {
        category: "Payments",
         icon: <ModulesSvg />,
        permission: 'payment.view',
        subcategories: [
          {
            moduleName: 'managePayments',
            roleName: "Payments",
             icon: <BoxSvg />,
            permission: 'payment.view'
          },
        ]
      },
      // {
      //   category: "Access Control",
      //   icon: <AccessControlSvg />,
      //   permission: 'access.control',
      //   subcategories: [
      //     {
      //       moduleName: 'manageModule',
      //       roleName: "Modules",
      //       icon: <ModulesSvg />,
      //       permission: 'module.view'
      //     },
      //     {
      //       moduleName: 'managePermissions',
      //       roleName: "Permissions",
      //       icon: <PermissionSvg />,
      //       permission: 'permission.view'
      //     },
      //     {
      //       moduleName: 'manageRoles',
      //       roleName: "Roles",
      //       icon: <RolesSvg />,
      //       permission: 'role.view'
      //     },
      //   ]
      // },
    ];

    if (isSuperAdmin) {
      const processedLinks = menuStructure.map(category => ({
        ...category,
        subcategories: category.subcategories.map(sub => ({
          ...sub,
          url: getModuleRoute(sub.moduleName) || getDefaultRoute(sub.moduleName)
        }))
      }));
      setLinks(processedLinks);
    } else {
      const accessibleModules = getAllAccessibleModules();
      const accessibleModuleNames = new Set(accessibleModules.map(m => m.moduleName));

      const filteredMenu = menuStructure
        .map(category => {
          const filteredSubcategories = category.subcategories
            .filter(sub => {
              return accessibleModuleNames.has(sub.moduleName) ||
                (sub.permission && hasPermission(sub.permission));
            })
            .map(sub => ({
              ...sub,
              url: getModuleRoute(sub.moduleName) || getDefaultRoute(sub.moduleName)
            }));

          if (filteredSubcategories.length > 0) {
            return { ...category, subcategories: filteredSubcategories };
          }
          return null;
        })
        .filter(category => category !== null);

      setLinks(filteredMenu);
    }
  }, [modules, loading, isSuperAdmin, getAllAccessibleModules, getModuleRoute, hasPermission]);

  useEffect(() => {
    if (links.length === 0) return;

    const currentPath = location.pathname;
    let activeCategory = null;

    links.forEach(category => {
      const hasActiveChild = category.subcategories.some(sub =>
        sub.url === currentPath || (sub.url !== '#' && currentPath.startsWith(sub.url))
      );
      if (hasActiveChild) {
        activeCategory = category.category;
      }
    });

    if (activeCategory && openCategory !== activeCategory) {
      setOpenCategory(activeCategory);
    }
  }, [location.pathname, links]);

  if (loading) {
    return (
      <div className={`admin-sidebar ${isOpen ? 'admin-expanded' : 'admin-collapsed'}`}>
        <div className="admin-sidebar-content">
          <div className="admin-logo-area">
            <div className="admin-logo">
              <img src="/image/footer-logo.png" alt="Logo" />
            </div>
          </div>
          <div className="admin-loading-spinner">
            <div className="admin-spinner"></div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {isOpen && <div className="admin-sidebar-backdrop" onClick={onToggle} />}

      <aside className={`sidebar ${isSidebarOpen ? "sidebar2" : ""}`}>
        <div className="admin-sidebar-content">
          <div className="admin-logo-section">
            <div className="admin-logo-wrapper">
              <img src={isOpen ? "/image/footer-logo.png" : "/image/logo-icon.png"} alt="Logo" />
            </div>

          </div>

          <nav className="admin-nav-menu">
            <NavLink
              to="/admin/dashboard"
              className={({ isActive }) => `admin-nav-link ${isActive ? 'admin-active' : ''}`}
              data-tooltip="Dashboard"
            >
              <span className="admin-nav-icon"><DashBoardSvg /></span>
              {isOpen && <span className="admin-nav-label">Dashboard</span>}
            </NavLink>
          </nav>

          <div className="admin-menu-container">
            {isOpen && <div className="admin-menu-title">MAIN MENU</div>}

            <div className="admin-menu-items">
              {links.length > 0 ? (
                links.map((category, idx) => (
                  <div key={idx} className="admin-menu-item-wrapper">
                    <div
                      className={`admin-menu-item ${openCategory === category.category ? 'admin-open' : ''}`}
                      onClick={() => isOpen && toggleCategory(category.category)}
                      data-tooltip={!isOpen ? category.category : ""}
                    >
                      <div className="admin-menu-item-content">
                        <span className="admin-menu-icon">{category.icon}</span>
                        {isOpen && <span className="admin-menu-label">{category.category}</span>}
                      </div>
                      {isOpen && (
                        <span
                          className={`admin-menu-arrow ${openCategory === category.category ? "rotate" : ""
                            }`}
                        >
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                            <path
                              d="M9 18L15 12L9 6"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      )}
                    </div>

                    <div
                      className={`admin-submenu ${openCategory === category.category ? "submenu-open" : ""
                        }`}
                    >
                      {category.subcategories.map((subItem, subIdx) => (
                        <NavLink
                          key={subIdx}
                          to={subItem.url}
                          className={({ isActive }) =>
                            `admin-submenu-link ${isActive ? "admin-active" : ""}`
                          }
                        >
                          <span className="admin-submenu-icon">{subItem.icon}</span>
                          <span className="admin-submenu-label">{subItem.roleName}</span>
                        </NavLink>
                      ))}
                    </div>
                  </div>
                ))
              ) : (
                <div className="admin-empty-menu">
                  {isOpen && <span>No modules available</span>}
                </div>
              )}
            </div>
          </div>

          {isOpen && (
            <div className="admin-sidebar-footer">
              <div className="admin-support-box">
                <div className="admin-support-icon">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="1.5" />
                    <path d="M12 16V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M12 8H12.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </div>
                <div className="admin-support-text">
                  <h4>Need Assistance?</h4>
                  <p>Get help from our support team</p>
                  <a href="/support" className="admin-support-link">Contact Support →</a>
                </div>
              </div>
            </div>
          )}
        </div>

        {!isOpen && (
          <button className="admin-expand-btn" onClick={onToggle}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
      </aside>
    </>
  );
};